// extracted by mini-css-extract-plugin
export var desktop = "styles-module--desktop--d7c4b";
export var mobile = "styles-module--mobile--86ac1";